/*
 * custom-mega-menu.js — georgatos.gr  v8
 *
 * Desktop mega-menu columns are server-rendered by Liquid into
 * #custom-mega-nav-data (snippets/custom-mega-nav.liquid).
 * This script only reads that pre-built HTML, clones it into each
 * nav dropdown panel, and registers Zest hover events.
 *
 * Trust/sale side panels removed (v8).
 * Μάρκες now also injected from Liquid for consistent rendering.
 * A "Δείτε Όλες τις Μάρκες" CTA is appended to the Μάρκες panel.
 *
 * To update menu links: Online Store → Navigation → Main menu.
 * No JS changes required.
 */
(function () {
  'use strict';

  /* The "see all brands" link URL is read directly from the nav
     linklist via custom-mega-nav.liquid — no hardcoded URL needed. */

  /* ================================================================
     INJECT LIQUID COLUMNS
     Reads pre-rendered HTML from #custom-mega-nav-data and clones
     it into the nav dropdown panel.
     ================================================================ */
  function injectLiquidColumns(ul, idx) {
    var src = document.querySelector('#custom-mega-nav-data [data-l1="' + idx + '"]');
    if (!src) return;

    /* Clear Zest-rendered items */
    Array.prototype.slice.call(ul.querySelectorAll(':scope > li'))
      .forEach(function (li) { ul.removeChild(li); });

    /* Clone and inject Liquid columns */
    Array.prototype.slice.call(src.querySelectorAll(':scope > li'))
      .forEach(function (col) { ul.appendChild(col.cloneNode(true)); });
  }

  /* ================================================================
     MAIN INIT
     ================================================================ */
  function init() {
    var topItems = document.querySelectorAll(
      '.f-site-nav__list > .f-site-nav__item--has-child'
    );

    topItems.forEach(function (item, idx) {
      var hasGrandchildren = item.querySelector('.f-site-nav__dropdown--level3');
      /* idx 3 = Μάρκες: plain link, no mega panel */
      if (idx === 3) return;
      if (!hasGrandchildren && idx !== 0 && idx !== 1 && idx !== 2 && idx !== 4) return;

      /* 1. Promote to mega */
      item.classList.add('f-site-nav__item--mega');
      var dropdown = item.querySelector('.f-site-nav__dropdown--level2');
      if (dropdown) {
        dropdown.classList.add('f-site-nav__dropdown--mega', 'no-js-hidden');
      }

      var inner = item.querySelector('.f-site-nav__dropdown-inner');
      if (!inner) return;

      /* 2. Inject Liquid-rendered columns for ALL menus */
      var ul = inner.querySelector('ul.list-none');
      if (ul) {
        ul.classList.add('f-grid', 'f-grid-6-cols');
        injectLiquidColumns(ul, idx);
      }
    });
  }

  /* ================================================================
     HOVER BINDING
     Re-registers mega items with Zest's SiteNav after our classes
     have been added (connectedCallback ran before init).
     ================================================================ */
  function bindZestHover() {
    var siteNav = document.querySelector('site-nav');
    if (!siteNav || !siteNav.isHover) return;

    siteNav.megaItems = siteNav.querySelectorAll('.f-site-nav__item--mega');
    siteNav.megaItems.forEach(function (megaItem, index) {
      megaItem.addEventListener('mouseenter', function (evt) {
        siteNav.onMenuItemEnter(evt, index);
      });
      megaItem.addEventListener('mouseleave', function () {
        clearTimeout(siteNav.timeoutEnter);
        megaItem.classList.remove('f-menu__item-active');
        clearTimeout(siteNav.timeoutLeave);
        siteNav.timeoutLeave = setTimeout(function () {
          siteNav.header.handleMegaItemDeactive();
        }, 300);
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); bindZestHover(); });
  } else {
    init();
    bindZestHover();
  }

})();
